import { getUser } from '@cast/infrastructure-auth';

export const wasDismissed = (type: string): boolean => {
  return !!localStorage.getItem(`dismissed-tour-${type}-${getUser()?.id}`);
};

export const setIsDismissed = (type: string): void => {
  localStorage.setItem(`dismissed-tour-${type}-${getUser()?.id}`, 'true');
};
